import type { TrackProperties } from "@/modules/tracking/generated-types/track"
import type { TrackEventPropertiesByEventName } from "@/modules/tracking/types"

/**
 * This function is only a type guard to ensure the event properties are well filled
 * according to the event name.
 */
export function ensureTrackingProps<EventName extends keyof TrackProperties>({
  eventName,
  eventProperties,
}: {
  eventName: EventName
  eventProperties: TrackEventPropertiesByEventName<EventName>
}): {
  /** This value must be filled only by ensureTrackingProps */
  _validated_with_ensureTrackingProps_method: true
  eventName: EventName
  eventProperties: TrackEventPropertiesByEventName<EventName>
} {
  return { _validated_with_ensureTrackingProps_method: true, eventName, eventProperties }
}
